import React from "react";
import { Box, Grid, Divider, Tooltip } from "@mui/material";
import { TooltipName } from "../../../../utils/Enums";
import archivedBoard from "../../../../styles/svg/Vector-archived.svg";
import { useNavigate } from "react-router-dom";
import { getLastSevenDays } from "../../../../utils/helpers";

function UserProfileSidebar({ profileData, onChangePassword , userId}) {
  const validBoards = profileData?.boards?.filter(
    (board) => board?.board_id !== null
  ) || [];
  
  const navigate = useNavigate();
  return (
    <>
      <Grid item xs={5} pr={6}>
        <ul style={{ paddingLeft: "14px" }}>
          <li onClick={() => navigate(`/my-task?tab=team&uid=${userId}`)} style={{ width: "fit-content", }}>
            Assigned Tasks
          </li>
          <li onClick={() => navigate(`/my-task?tab=worklog&date=${getLastSevenDays()}&uid=${userId}`)} style={{ width: "fit-content",}}>Worklogs</li>
          <li onClick={onChangePassword} style={{ width: "fit-content" }}>
            Change Password
          </li>
        </ul>

        <p className="head-user-profile">Boards</p>
        <Box
          className="custom-scrollbar"
          sx={{
            overflowY: "auto",
            maxHeight: "calc(100vh - 410px)",
            minHeight: "200px",
            paddingRight: '12px',
          }}
        >
          {validBoards.length > 0  ? (
            <ul style={{ paddingLeft: "14px" }}>
              {profileData?.boards.map((ele, idx) => (
                <li key={idx}>
                  <div className="boards-user-profile">
                    <p>{ele.board_name}</p>
                    {ele.is_archive && (
                      <Tooltip title={TooltipName.MANAGE_USER.ARCHIVED_BOARD}>
                        <img src={archivedBoard} alt="archived board" />
                      </Tooltip>
                    )}
                  </div>
                </li>
              ))}
            </ul>
          ) : (
            "No boards assigned yet"
          )}
        </Box>
      </Grid>
      <Divider orientation="vertical" variant="middle" flexItem />
    </>
  );
}

export default React.memo(UserProfileSidebar);
